// The game's control reference, as data. Shared by the /help modal and the controls page of the
// character-creation screen so the two can never drift apart.

export interface HelpEntry {
    title: string
    body: string
}

export const HELP_ENTRIES: HelpEntry[] = [
    { title: "Movement", body: "WASD, or Arrow Keys. Press SHIFT to run." },
    { title: "Interactions", body: "Mouse over an object to reveal its interaction icons." },
    { title: "Combat & Mining", body: "Left-click or press space to attack or mine an object." },
    { title: "Inventory", body: "Press 'i' or click on the inventory icon to access your inventory." },
    { title: "Chat", body: "Press enter to send a world-wide message." },
    { title: "Help", body: "Type '/help' to get some help." },
    { title: "Register", body: "Type '/register' to create an account and save your progress." },
]
